import React from "react";
import "./style.css";

/**
 * PloomPageHero — standardized page header used on every subpage
 * (/despre, /evenimente, /contact, ...).
 *
 * Follows the canonical section template:
 *   pre-title → title → subtitle → optional description.
 *
 * Props:
 *   - preTitle  (string)  uppercase eyebrow
 *   - title     (string)  main page title
 *   - subtitle  (string)  italic descriptor under title
 *   - description (string, optional) longer paragraph
 */
const PloomPageHero = ({ preTitle, title, subtitle, description }) => {
  return (
    <section className="new-page-hero">
      <div className="new-page-hero__inner">
        {preTitle ? (
          <span className="new-page-hero__pre-title">{preTitle}</span>
        ) : null}
        <h1 className="new-page-hero__title">{title}</h1>
        {subtitle ? (
          <p className="new-page-hero__subtitle">{subtitle}</p>
        ) : null}
        {description ? (
          <p className="new-page-hero__desc">{description}</p>
        ) : null}
      </div>
    </section>
  );
};

export default PloomPageHero;
